// extracted by mini-css-extract-plugin
export default {"appBar":"ModalViewPDF_appBar__CYFjU","buttonSave":"ModalViewPDF_buttonSave__FWiM-","flex":"ModalViewPDF_flex__wUgJQ","iconNavigation":"ModalViewPDF_iconNavigation__ASvkO"};